<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import readXlsFile from 'read-excel-file'
import { habeasMethods } from '@state/helpers'
import { BIcon, BIconQuestionCircle } from 'bootstrap-vue'

export default {
  page: {
    title: 'Cargar Habeas Data',
    meta: [{ name: 'Cargar Habeas Data', content: 'Cargar Habeas Data' }],
  },
  components: { Layout, PageHeader, BaseDatatable, BIconQuestionCircle, BIcon, },
  data() {
    return {
      title: 'Cargar Habeas Data',
      items: [
        { text: 'Home', href: '/' },
        { text: 'Cargar Habeas Data', active: true },
      ],
      tableHeaders: [
        { key: 'index', label: '#' },
        { key: 'status', label: 'Validación', sortable: true },
        { key: 'nombre', label: 'Nombre' },
        { key: 'apellido_1', label: 'Primer apellido' },
        { key: 'apellido_2', label: 'Segundo apellido' },
        { key: 'tipo_documento', label: 'Tipo documento' },
        { key: 'documento', label: 'Documento' },
        { key: 'sexo', label: 'Sexo' },
        { key: 'celular', label: 'Celular' },
        { key: 'email', label: 'Correo' },
        { key: 'ip', label: 'IP' },
        { key: 'dispositivo', label: 'Dispositivo' },
        // { key: 'marca', label: 'Marca' },
        // { key: 'modelo', label: 'Modelo' },
        { key: 'canal', label: 'Canal' },
        { key: 'habeas_data', label: 'Habeas data' },
        { key: 'fecha', label: 'Fecha' },
      ],
      helpTableHeaders: [
        { key: 'field', label: 'Campo' },
        { key: 'required', label: 'Obligatorio' },
        { key: 'condition', label: 'Condiciones' },
      ],
      helpItems: [
        { field: 'nombre', required: 'Si', condition: ['Longitud máxima: 40']},
        { field: 'apellido_1', required: 'Si', condition: ['Longitud máxima: 40']},
        { field: 'apellido_2', required: 'No', condition: ['Longitud máxima: 40']},
        { field: 'tipo_documento', required: 'Si', condition: [
          'Tipo de documento de identidad', 'CC: cedula de ciudadanía', 'N: nit']},
        { field: 'documento', required: 'Si', condition: [
          'Documento de identidad válido', 'Longitud mínima: 6', 'Longitud máxima: 12']},
        { field: 'sexo', required: 'No', condition: ['0: No aplica', '1: Femenino', '2: Masculino']},
        { field: 'celular', required: 'Si', condition: ['Longitud máxima: 15', 'Formato: Numérico']},
        { field: 'email', required: 'Si', condition: ['Correo electrónico válido']},
        { field: 'ip', required: 'Si', condition: ['Longitud máxima: 20', 'Formato: IPV4']},
        { field: 'marca', required: 'Si', condition: [
          'Marca del dispositivo', 'Longitud máxima: 20', 'N/A si no aplica']},
        { field: 'modelo', required: 'Si', condition: [
          'Modelo del dispositivo', 'Longitud máxima: 20', 'N/A si no aplica']},
        { field: 'canal', required: 'Si', condition: ['Canal de captación', 'Longitud máxima: 30']},
        { field: 'habeas_data', required: 'Si', condition: [
          'Aceptación de habeas data', '1: Acepta', '2: No acepta']},
        { field: 'fecha', required: 'No', condition: ['Formato: YYYY-MM-DD']},
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      file: null,
      data: [],
      okData: true,
      isWarningModalOpen: false,
      isSendingData: false,
      fileName: '',
    }
  },
  computed: {},
  methods: {
    ...habeasMethods,

    readXlsFile,
    async transformData() {
      if (this.file) {
        await readXlsFile(this.file)
          .then((rows) => {
            this.totalRows = rows.length - 1
            this.data = []
            this.okData = true
            rows.forEach((row, index) => {
              if (index > 0) {
                this.data.push(this.formatData(row, index))
              }
            })
          })
          .catch((e) => this.$axios_error_noty(e, this))
        if(!this.okData) {
          this.isWarningModalOpen = true
        }
        this.fileName = this.file.name
        this.file = null
      }
    },

    formatData(value, index) {
      let dateString = null
      if(value[13] instanceof Date) {
        dateString = value[13].toLocaleDateString(
          'en-CA', 
          {month: '2-digit', day: '2-digit', year: 'numeric', timeZone: 'UTC'})
      } else {
        dateString = value[13]
      }
      let obj = {
        index: index + 1,
        nombre: value[0],
        apellido_1: value[1],
        apellido_2: value[2],
        tipo_documento: value[3],
        documento: value[4],
        sexo: value[5],
        celular: value[6],
        email: value[7] instanceof String ? value[7].toLowerCase() : value[7],
        ip: value[8],
        dispositivo: {
          marca: (value[9] != null && value[9] != '') ? value[9] : 'N/R',
          modelo: (value[10] != null && value[10] != '') ? value[10] : 'N/R',
        },
        canal: value[11],
        habeas_data: value[12],
        fecha: dateString,
        _cellVariants: {},
        status: true,
        error_details: []
      }
      return this.validateData(obj)
    },

    validateData(obj) {
      // let exr = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
      let exr = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const exr_phone = /^[0-9]*$/
      const exr_ipv4 = /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/
      const exr_date = /^\d{4}-\d{2}-\d{2}$/
      const exr_email_user = /^[0-9a-zA-Z\.\_]*$/ // Some emails use _
      const exr_email_user_end = /^[0-9a-zA-Z]$/
      let email_parts = null

      // * nombre: campo obligatorio
      if (!obj.nombre) this.markCell(obj, 'nombre', 'Nombre es obligatorio')
      // * apellido_1: campo obligatorio
      if (!obj.apellido_1) this.markCell(obj, 'apellido_1', 'Primer apellido es obligatorio')
      // * tipo_documento: obligatorio y debe ser CC o N
      if (!obj.tipo_documento) this.markCell(obj, 'tipo_documento', 'Tipo de documento es requerido')
      else if (!(obj.tipo_documento == 'CC' || obj.tipo_documento == 'N'))
        this.markCell(obj, 'tipo_documento', 'El tipo de documento debe ser CC o N')
      // * documento: obligatorio y no debe ser mayor a 12 caracteres
      if (!obj.documento) this.markCell(obj, 'documento', 'El documento es obligatorio')
      else if (String(obj.documento).length > 12) this.markCell(obj, 'documento', 'El documento acepta máximo 12 caracteres')
      else if (String(obj.documento).length < 6) this.markCell(obj, 'documento', 'El documento acepta mínimo 6 caracteres')
      // * email: obligatorio y debe tener formato de correo electrónico
      if (obj.email) email_parts = obj.email.split('@', 2)
      if (!obj.email) this.markCell(obj, 'email', 'El correo electrónico es obligatorio')
      else if (!exr.test(obj.email)) this.markCell(obj, 'email', 'El correo electrónico es inválido')
      else if (!exr_email_user.test(email_parts[0])){
        this.markCell(obj, 'email', 'El correo electrónico solo permite letras, números y puntos')
      }
      else if(!exr_email_user_end.test(email_parts[0].charAt(email_parts[0].length - 1))) {
        this.markCell(obj, 'email', 'El último caracter del usuario de correo electrónico deber ser un número o una letra (a-z)')
      }
      else if(email_parts[1].length > 63){
        this.markCell(obj, 'email', 'El dominio del correo electrónico no debe ser mayor a 63 caracteres')
      } 

      // * habeas_data: es obligatorio y debe ser un numero entre 1 y 2
      if (typeof obj.habeas_data != 'number')
        this.markCell(obj, 'habeas_data', 'El valor de habeas data debe ser numérico')
      else if (obj.habeas_data < 1 || obj.habeas_data > 2)
        this.markCell(obj, 'habeas_data', 'El valor de habeas data deber ser 1 o 2')
      // * sexo: no es obligatorio pero si esta debe ser un numero entre 0 y 2
      if (obj.sexo)
        if (typeof obj.sexo != 'number') this.markCell(obj, 'sexo', 'El valor de sexo debe ser numérico')
        else if (obj.sexo < 0 || obj.sexo > 2) this.markCell(obj, 'sexo', 'El valor de sexo deber ser 0, 1 o 2')
      // * ip: campo obligatorio, !faltaria comprobar formato de IPv4
      if (!obj.ip) this.markCell(obj, 'ip', 'La ip es requerida')
      else if (String(obj.ip).length > 20) this.markCell(obj, 'ip', 'La ip acepta máximo 20 caracteres')
      else if (!exr_ipv4.test(obj.ip)) this.markCell(obj, 'ip', 'La ip debe tener formato IPV4')
      // * dispositivo: campo obligatorio, marca y modelo son obligatorios
      if (!obj.dispositivo) this.markCell(obj, 'dispositivo', 'El dispositivo es requerido')
      if (!obj.dispositivo.marca) this.markCell(obj, 'dispositivo', 'La marca del dispositivo es requerida')
      else if (String(obj.dispositivo.marca).length > 20) this.markCell(obj, 'dispositivo', 'La marca acepta máximo 20 caracteres')
      if (!obj.dispositivo.modelo) this.markCell(obj, 'dispositivo', 'El modelo del dispositivo es requerido')
      else if (String(obj.dispositivo.modelo).length > 20) this.markCell(obj, 'dispositivo', 'El modelo acepta máximo 20 caracteres')
      // * canal: campo obligatorio
      if (!obj.canal) this.markCell(obj, 'canal', 'El canal es requerido')
      else if (String(obj.canal).length > 30) this.markCell(obj, 'canal', 'El canal acepta máximo 30 caracteres')
      // * celular: obligatorio y solo números
      if (!obj.celular) this.markCell(obj, 'celular', 'El celular es requerido')
      else if (String(obj.celular).length > 15) this.markCell(obj, 'celular', 'El celular acepta máximo 15 caracteres')
      else if (!exr_phone.test(obj.celular)) this.markCell(obj, 'celular', 'El celular no debe tener letras')
      // * fecha: opcional pero en formato YYYY-MM-DD
      if (obj.fecha)
        if (!exr_date.test(obj.fecha)) this.markCell(obj, 'fecha', 'La fecha requiere formato YYYY-MM-DD')
        else if (!Date.parse(obj.fecha)) this.markCell(obj, 'fecha', 'Valor de fecha incorrecto')
      return obj
    },

    markCell(obj, cell, error) {
      obj._cellVariants[cell] = 'danger'
      obj.status = false
      obj.error_details.push(error)
      this.okData = false
    },

    valueSexo(n) {
      if (n == 0) return 'No Aplica'
      if (n == 1) return 'Femenino'
      if (n == 2) return 'Masculino'
    },

    async sendData() {
      let dataClone = this.data.map(a => {return {...a}})
      dataClone.forEach(entry => {
        this.cleanObject(entry)
        if(entry.fecha) {
          entry.fecha += "T00:00:00-05:00"
        }
      })
      this.isSendingData = true
      try {
        await this.createBulkHabeasAction(dataClone)
      } catch (error) {
        this.$axios_error_noty(error, this)
        this.isSendingData = false
        return
      }
      this.$generate_toast(this, 'success', 'Datos enviados correctamente')
      this.data = []
      this.file = null
      this.isSendingData = false
    },

    cleanObject(obj) {
      Object.keys(obj).forEach(key => {
        if (obj[key] === null || obj[key] === undefined) {
          delete obj[key];
        }
      });
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="p-4 m-0 bg-white">
      <!-- help button -->
      <div class="row justify-content-end">
        <b-button v-b-modal.modal-help
          class="rounded-circle p-0"
          variant="primary"
        >
          <b-icon
            icon="question-circle"
            style="width: 40px; height: 40px"
          >
          </b-icon>
        </b-button>
      </div>

      <!-- upload -->
      <h5 class="lead">
        <i class="fas fa-cloud-upload-alt"></i> Subir información masiva
      </h5>
      <b-form-file
        v-model="file"
        accept=".xlsx, .xls, .csv"
        placeholder="Seleccionar o arrastrar aquí"
        drop-placeholder="Soltar aquí"
        browse-text="Buscar"
        @input="transformData"
      ></b-form-file>
      <div>
        <small>Formatos permitidos: .xlsx, .xls y .csv</small>
      </div>
      <div v-if="data.length" class="mt-3 text-center">
        <p>
          <b>
            Archivo seleccionado:
            <span class="text-primary">
              {{ fileName }}
            </span>
          </b>
        </p>
        <b-button variant="primary" :disabled="!okData || isSendingData" @click="sendData">
          <i class="fas fa-upload fa-lg mr-1"></i> Enviar
          <b-spinner v-if="isSendingData" label="Spinning" small></b-spinner>
        </b-button>
        <p v-if="!okData">
          <small class="text-danger">
            No se puede enviar la información. Los datos cargados tienen errores.
          </small>
        </p>
      </div>
      <!-- data.length: {{ data.length }} <br /> -->
      <!-- <pre>{{ data }}</pre>  // ! ACA SE GUARDA LA DATA A ENVIAR, YA ESTA FORMATEADA [ {}, {} ]   -->  
      <!-- {{okData}} // ! ESTA VARIABLE INDICA SI SE PUEDE ENVIAR LA DATA O NO, SEGUN VALIDACIONES -->
      <b-row v-if="data.length" class="mt-4">
        <b-col class="col-auto my-1">
          <b-form-group
            label="Registros por página"
            label-for="per-page-select"
            label-cols="auto"
            label-align-sm="left"
            label-size="sm"
            class="mb-0"
          >
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="sm"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        v-if="data.length"
        :items="data"
        :fields="tableHeaders"
        :current-page="currentPage"
        :per-page="perPage"
        :responsive="true"
      >
        <template v-slot:cell(index)="data">
          <span v-if="data.item.status">{{data.item.index}}</span>
          <span v-if="!data.item.status" class="text-danger">{{data.item.index}}</span>
        </template>
        <template v-slot:cell(status)="data">
          <i v-if="data.item.status" class="fas fa-check-circle fa-lg text-success"></i>
          <i :id="`status-cell-${data.index}`" v-show="!data.item.status" class="fas fa-times-circle fa-lg text-danger"></i>
          <b-tooltip :target="`status-cell-${data.index}`" triggers="hover" variant="warning">
            <ul class="pl-2 text-left">
              <li 
                v-for="(error, index) in data.item.error_details" :key="index"
              >
                {{ error }}
              </li>
            </ul>
          </b-tooltip>
        </template>
        <template v-slot:cell(sexo)="data">
          {{ valueSexo(data.item.sexo) }}
        </template>
        <template v-slot:cell(dispositivo)="data">
          <p class="p-0 m-0">Marca: {{ data.item.dispositivo.marca }}</p>
          <p class="p-0 m-0">Modelo: {{ data.item.dispositivo.modelo }}</p>
        </template>
        <template v-slot:cell(habeas_data)="data">
          <b-badge v-if="data.item.habeas_data == 0"> No especifica </b-badge>
          <b-badge v-if="data.item.habeas_data == 1" variant="success">
            Acepta
          </b-badge>
          <b-badge v-if="data.item.habeas_data == 2" variant="danger">
            No Acepta
          </b-badge>
        </template>
        <!-- <template v-slot:cell()="data">
          <span v-b-tooltip.hover title="fdsaf">{{ data.value }}</span>
        </template> -->
      </b-table>
      <b-row v-if="data.length">
        <b-col sm="5" md="4" class="my-1">
          Mostrando {{ !totalRows ? 0 : (currentPage - 1) * perPage + 1 }} -
          {{
            !totalRows
              ? 0
              : currentPage * perPage >= totalRows
              ? totalRows
              : currentPage * perPage
          }}
          de {{ totalRows }}
          Registros
        </b-col>
        <b-col offset-md="5" sm="7" md="3" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="md"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>

    <!-- warning modal -->
    <b-modal 
      id="modal-center" centered title="Advertencia" v-model="isWarningModalOpen"
      title-class="title-variant" header-bg-variant="warning"
      ok-only hide-header-close
    >
      <p class="my-4 mx-2 h5">
        Se encontraron errores en la información suministrada. 
        Verifique los errores en el ícono
        <i class="fas fa-times-circle fa-md text-danger"></i> de cada fila. 
        <br> <br>
        No podrá enviar la información hasta que corrija los errores.
      </p>
    </b-modal>

    <!-- help modal -->
    <!-- <b-modal id="modal-help" scrollable title="Instructivo" size="lg" ok-only>
      
    </b-modal> -->
    <b-modal 
      id="modal-help" centered title="Información"
      title-class="title-variant" header-bg-variant="primary"
      ok-only hide-header-close size="lg"
    >
      <div class="mx-3">
        <h5 class="mb-4">
          Cargue un archivo xlsx, xls o csv con los registros de habeas data.
          En esta tabla se resumen las características de la información requerida:
        </h5>
        <b-table striped hover :items="helpItems" :fields="helpTableHeaders">
          <template v-slot:cell(condition)="data">
            <ul class="pl-2 text-left mb-0">
              <li 
                v-for="(condition, index) in data.item.condition" :key="index"
              >
                {{ condition }}
              </li>
            </ul>
          </template>
        </b-table>
      </div>
    </b-modal>
  </Layout>
</template>

<style>
  .title-variant {
    color: white !important;
  }
</style>